import "../../util/styles/Global.css";
import "./Resume.css";
import image from '../../images/selfie_headshot_1.png';
import { Collapse, List, ListItem, ListItemButton } from "@mui/material";
import { useState } from "react";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExperienceRanking from "./experience-ranking/ExperienceRanking";
import { GitHub, LinkedIn, LocationOn } from "@mui/icons-material";

class Skill {
  constructor(
    name, ranking
  ) {
    this.name = name;
    this.ranking = ranking;
  }
}

const baseUrl = "https://nicgauer.com";
const githubLink = process.env.REACT_APP_GITHUB_LINK;
const linkedInLink = process.env.REACT_APP_LINKEDIN_LINK;

export default function Resume(props) {

  const [open, setOpen] = useState(true);

  const generalSkillsList = [
    new Skill(
      "Full Stack Web Development", 5
    ),
    new Skill(
      "Front-End Web Development", 4
    ),
    new Skill(
      "Back-End Web Development", 5
    ),
    new Skill(
      "Dev Ops", 5
    ),
    new Skill(
      "Platform Engineering and Design", 4
    ),
    new Skill(
      "Agile Team Management", 4
    ),
    new Skill(
      "CI/CD Design", 3
    ),
    new Skill(
      "Communication", 5
    ),
    new Skill(
      "Public Speaking", 5
    )
  ];

  const technicalSkillsList = [
    new Skill(
      "Javascript", 5
    ),
    new Skill(
      "Typescript", 5
    ),
    new Skill (
      "Java", 5
    ),
    new Skill (
      "SQL", 4
    ),
    new Skill(
      "Python", 3
    ),
    new Skill(
      "C", 2
    ),
    new Skill(
      "C#", 2
    ),
    new Skill(
      "C++", 2
    ),
    new Skill(
      "CSS / SCSS", 4
    ),
    new Skill(
      "Docker", 5
    ),
    new Skill(
      "Angular", 4
    ),
    new Skill(
      "React", 4
    ),
    new Skill(
      "React Native", 2
    ),
    new Skill(
      "SpringBoot", 5
    ),
    new Skill(
      "Quarkus", 4
    ),
    new Skill(
      "Flask", 3
    ),
    new Skill(
      "Express", 3
    ),
    new Skill(
      "PostgreSQL", 5
    ),
    new Skill(
      "SQLite", 4
    ),
    new Skill(
      "Unity", 4
    ),
    new Skill(
      "Unreal Engine", 3
    ),
    new Skill(
      "Ableton", 5
    ),
    new Skill(
      "Go", 2
    ),
    new Skill(
      "Ruby", 1
    ),
    new Skill(
      "NextJS", 4
    ),
    new Skill(
      "PayloadCMS", 4
    ),
    new Skill(
      "Jest", 4
    ),
    new Skill(
      "Playwright", 3
    ),
    new Skill(
      "Storybook", 2
    ),
    new Skill(
      "NPM Package Management", 4
    ),
    new Skill(
      "Terraform", 2
    )
  ]

  const handleClick = () => {
    setOpen(!open);
  }

  const generateListItemWithSkills = (skillsList, outline=true) => {
    return skillsList.map((skill, i) => (
      <ListItem 
        className={outline ? "list-item-outline" : null}
        key={i}
      >
        <div>

        <span 
          className={"skill-text"}
        >
          {skill.name}
        </span>
        <ExperienceRanking style={{marginTop: "10px"}} ranking={skill.ranking} />
        </div>
      </ListItem>
    ))
  }

  return (
    <div
      // className="animated-background"
    >

      <div
        className="resume-header"
      >
        <img 
          className="profile-image"
          src={image} 
          alt="selfie"
        />

        <div
          className="resume-header-content"
        >
          <div
            className="spread-out"
          >
            <h1
              className="resume-header-title"
            >
              Nic Gauer
            </h1>

            <div>
              <a
                style={{color:"white"}}
                target="_blank"
                rel="noreferrer"
                href={githubLink}
              >
                <GitHub />
              </a>

              <a
                style={{color:"white", marginLeft:".5em"}}
                target="_blank"
                rel="noreferrer"
                href={linkedInLink}
              >
                <LinkedIn />
              </a>
            </div>
          </div>

            <h3
              className="resume-header-subtitle"
            >
              Software Engineer
            </h3>

          <h6
            className="resume-header-subtitle"
          >
            Specialized in Full Stack Web Development, System Design, QA & Dev Ops
          </h6>

          <p
            className="resume-header-subtext"
          >
            5+ years of professional experience in developing, deploying, and maintaining websites, web hosted enterprise applications, and video games
          </p>

          <h2
            className="resume-header-subtext"
            style={{
              display:"flex", 
              alignItems:"center"
            }}
          >
            <LocationOn /> Minneapolis, MN
          </h2>

          <div className="resume-header-subtext" id="contact-span">
            <a
              target="_blank"
              rel="noreferrer"
              href={baseUrl + "/about"}
            >
              about
            </a>

            <span
              className="spacer"
            >
              |  
            </span> 

            <a
              target="_blank"
              rel="noreferrer"
              href={baseUrl + "/resume/projects"}
            >
              projects
            </a>

          </div>
        </div>
        
      </div>

      <div
        className="container"
      >
        <div
          className="main-section"
        >
          <div>
            <h3
              className="skills-header"
            >
              Experience
            </h3>

            <div>
              <a target="_blank" rel="noreferrer" href="https://www.goeverblue.com/">
                <h3 className="no-margin">
                  Everblue
                </h3>
              </a>
              <div 
                className="spread-out"
              >
                <h5 className="no-margin">
                  Staff Software Engineer - Tech Lead
                </h5>
                
                <span
                  className="date-span"
                >
                  June 2025 - current
                </span>
              </div>

              <p
                className="description"
              >
                A SaaS company that provides technology solutions for training, licencures, certifications, and rebate programs for public and private sector clients.  Based in North Carolina.  
                Worked as a Senior developer and Tech Lead for EverServe; an extensible web form and workflow platform built to operate, apply for, and review government licencure and assistance programs such as HOMES, HEAR, and WAP for multiple states.  
              </p>

              <div>
                <ul className="central-inner-list">
                  <li>
                    Lead a team of 8 developers through product discovery, initial pilot, and initial launch of multiple software solutions for several states and programs
                  </li>
                  <li>
                    Completed Full-Stack feature design and development using various technologies and tech stacks including TypeScript, React, NextJS, Payload CMS, Python, and Postgres
                  </li>
                  <li>
                    Dev Ops and QA duties such as managing repos, database migrations, deployments, CI/CD pipelines, and releases & automated release notes using tools like Docker, Terraform, Github Actions, Playwright, and various AWS services such as Cloudwatch, ECR, ECS, GuardDuty, and RDS
                  </li>
                  <li>
                    Implemented automated testing features including automated end to end tests, database migration tests, and unit tests to ensure products remain live and catch bugs before they're deployed 
                  </li>
                  <li>
                    Established an organized workflow pattern using Agile methodology using management tools such as Jira, and completed Agile admin duties like leading standups and meetings, scheduling meetings, and maintaining predictable timelines
                  </li>
                  <li>
                    Worked alongside client representiatives and system stakeholders to translate feature requests and bug reports into Jira tickets for developers.
                  </li>
                  <li>
                    Reviewed Pull Requests, conducted code reviews with developers, and manually tested features and releases and wrote automated tests
                  </li>
                  <li>
                    General Agile admin duties like leading standups, scheduling meetings, writing tickets, and assigning work for developers
                  </li>
                </ul>
              </div>

            </div>

            <div>
              <a target="_blank" rel="noreferrer" href="https://xorfox.com/">
                <h3 className="no-margin">
                  Xorfox
                </h3>
              </a>
              <div 
                className="spread-out"
              >
                <h5 className="no-margin">
                  Senior Software Engineer
                </h5>
                
                <span
                  className="date-span"
                >
                  June 2021 - May 2025
                </span>
              </div>

              <p
                className="description"
              >
                A healthcare focused SaaS company based in Denver, CO that built, developed, and maintained custom web hosted applications for coorperate clients.  
                Worked as a Junior, Mid level, and Senior full-stack software engineer.    
              </p>

              <div>
                <ul className="central-inner-list">
                  <li>
                    Balanced working on multiple products and teams at the same time while maintaining consistent quality and velocity
                  </li>
                  <li>
                    Worked alongside clients to turn feature and product ideas into trackable Jira tickets, then developed them alogside other developers in an Agile, HIPAA & SOC2 compliant environment
                  </li>
                  <li>
                    Designed and developed test driven, full stack web features using React, Springboot, Keycloak, Angular, Kafka, Express, Postgres, Docker, Jenkins 
                  </li>
                  <li>
                    Presented demos of new features and releases to clients and product stakeholders.  Trained end users on how to use and maintain products and features.
                  </li>
                  <li>
                    Created flexible local development tools that helped increase team velocity and reduce manual testing time
                  </li>
                </ul>
              </div>

            </div>
          </div>


        <div>


            
            <div
          className="education-section"
        >
          <h3
            className="skills-header"
          >
            Education
          </h3>

          <div>
            <a target="_blank" rel="noreferrer" href="https://www.uwsp.edu/">
              <h3 className="no-margin">
                University of Wisconsin - Stevens Point
              </h3>
            </a>
              <div 
                className="spread-out"
              >
                <h5 className="no-margin">
                  Bacheleor's Degree
                </h5>              
            </div>
          </div>


          <div>
            <div 
            >
              <a target="_blank" rel="noreferrer" href="https://www.appacademy.io/">
                <h3 className="no-margin">
                  App Academy
                </h3>
              </a> 
              <div 
                className="spread-out"
              >
                <h5 className="no-margin">
                  Completion Certificate
                </h5>              
            </div>
            </div>

            <p>
              software development certification course with focus on full stack web development.  There, I developed full stack apps using React, Docker, Heroku, Postgresql, and several different backends including Node and Flask.	 
            </p>
          </div>

        </div>


          <div>
            <h3
              className="skills-header"
            >
              Certifications
            </h3>
            <div 
              className="spread-out"
            >
              <a target="_blank" rel="noreferrer" href="https://aws.amazon.com/certification/certified-cloud-practitioner/">
                <h3 className="no-margin">
                AWS Cloud Practitioner
                </h3>
              </a>                   
            </div>
          </div>

        </div>
        </div>

        <div
          className="skills-section"
        >
          <h3
            className="skills-header"
          >
            Skills
          </h3>

          <div
            className="skills-list"
          >
            <List>

              {generateListItemWithSkills(generalSkillsList)}

              <ListItemButton onClick={handleClick}>
                  <span style={{marginRight:"auto"}}>
                    Technical Skills
                  </span>
                  {open ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={open} timeout="out" unmountOnExit>
                <List
                  className="inner-list"
                >
                  {generateListItemWithSkills(technicalSkillsList, false)}
                </List>
              </Collapse>
            </List>
          </div>
        </div>
      </div>
    </div>
  )
}